import { Action } from 'redux';

import { IAlertListInfo } from '../../ts/models/IAlertInfo';
import { UpdateAlerts } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';

export interface UpdateAlertsAction extends Action, IAlertListInfo {}

export function updateAlertsAction(info: IAlertListInfo): UpdateAlertsAction {
  return {
    type: UpdateAlerts,
    alerts: info.alerts,
    total: info.total
  };
}

export const isUpdateAlertsAction = isActionFactory<UpdateAlertsAction>(UpdateAlerts);
